import {Editor, Range, Transforms} from "../../../../../../pkg/slate.js";
export const wrapNodes = (editor, element, options = {}) => {
  if (Range.isRange(options.at)) {
    options.at = Editor.unhangRange(editor, options.at, {
      voids: options.voids
    });
  }
  Transforms.wrapNodes(editor, element, options);
};
